export const PaymentAssignmentTypes = [
    'NotSetAction',
    'ShortPayAction',
    'PartialPayAction',
    'PaymentAction',
    'OverPayAction',
    'NonFactoredPaymentAction',
];
const PAYMENT_ASSIGNMENT_STATES = ['pending', 'processed'];
